enum SchedulerItemEntities {
  MANAGER = "MANAGER",
  PROJECT = "PROJECT",
  ACTIVITY = "ACTIVITY",
}

export default SchedulerItemEntities;